module.exports = __webpack_public_path__ + "4af91c061b278272d87f9b9488ab19c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/og_image.png
// module id = 1772
// module chunks = 55